import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useSeo } from "../lib/seo";
import BookCard from "../components/BookCard";
import Skeleton from "../components/Skeleton";

export default function Books() {
  const [params, setParams] = useSearchParams();
  const type = params.get("jenis") || "";
  const [data, setData] = useState({ items: [], types: [] });
  const [loading, setLoading] = useState(true);
  const [contentPage, setContentPage] = useState({});

  useSeo({ title: "Buku & Karya — Heri Sensei", description: "Katalog buku, e-book, dan panduan karya Heri Sensei.", path: "/buku-karya" });

  useEffect(() => {
    api.get("/content/books").then((r) => setContentPage(r.data || {})).catch(() => setContentPage({}));
  }, []);

  useEffect(() => {
    setLoading(true);
    const qs = type ? `?type=${encodeURIComponent(type)}` : "";
    api.get(`/books${qs}`)
      .then((r) => setData(r.data))
      .catch(() => setData({ items: [], types: [] }))
      .finally(() => setLoading(false));
  }, [type]);

  const setParam = (value) => {
    const next = new URLSearchParams(params);
    if (value) next.set("jenis", value); else next.delete("jenis");
    setParams(next);
  };

  const pageCopy = contentPage || {};

  return (
    <div data-testid="books-page" className="max-w-6xl mx-auto px-4 sm:px-8 py-14 md:py-20">
      <p className="text-xs uppercase tracking-[0.22em] font-semibold text-enji">{pageCopy.eyebrow || "Buku & Karya"}</p>
      <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mt-4 text-ink">{pageCopy.title || "Karya yang bisa Anda bawa pulang"}</h1>
      <p className="text-sub mt-4 max-w-xl">{pageCopy.intro || "Checkout dilakukan dengan aman melalui Lynk.id — tombol pembelian akan membawa Anda ke halaman produk yang benar."}</p>

      {data.types && data.types.length > 1 && (
        <div className="flex gap-2 overflow-x-auto no-scrollbar mt-10 pb-1" role="group" aria-label="Filter jenis karya">
          <button
            data-testid="book-type-chip-semua"
            onClick={() => setParam("")}
            className={`shrink-0 px-4 py-2 rounded-full text-sm font-medium border transition-colors ${!type ? "bg-enji text-white border-enji" : "border-line bg-surface text-sub hover:text-ink"}`}
          >
            Semua
          </button>
          {data.types.map((t) => (
            <button
              key={t}
              data-testid={`book-type-chip-${t.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => setParam(type === t ? "" : t)}
              className={`shrink-0 px-4 py-2 rounded-full text-sm font-medium border transition-colors ${type === t ? "bg-enji text-white border-enji" : "border-line bg-surface text-sub hover:text-ink"}`}
            >
              {t}
            </button>
          ))}
        </div>
      )}

      {loading ? (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12" aria-busy="true">
          {[1, 2, 3, 4].map((i) => (
            <Skeleton key={i} className="h-80" />
          ))}
        </div>
      ) : data.items.length === 0 ? (
        <div data-testid="books-empty" className="mt-16 text-center border border-dashed border-line rounded-xl py-20">
          <span className="w-2.5 h-2.5 rounded-full bg-enji inline-block mb-5" />
          <p className="font-serif text-2xl text-ink">{pageCopy.empty_title || "Katalog masih disiapkan"}</p>
          <p className="text-sub mt-2 max-w-sm mx-auto">{pageCopy.empty_text || "Karya akan segera tampil di sini setelah diterbitkan melalui admin."}</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12">
          {data.items.map((b, i) => (
            <BookCard key={b.id} book={b} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
